import { memo } from 'react'
import classes from "./styles.module.css";

interface AnimatedBGProps {
    className?: string;
}

function AnimatedBG({ className = '' }: AnimatedBGProps) {
    return (
        <ul className={[classes.circles, className].join(' ').trim()}>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
        </ul>
    )
}

export default memo(AnimatedBG);
